import { cn } from "@/lib/utils";

interface FormActionsProps {
  children: React.ReactNode;
  className?: string;
  alignment?: "left" | "center" | "right";
  variant?: "page" | "modal";
}

export function FormActions({
  children,
  className,
  alignment = "right",
  variant = "page",
}: FormActionsProps) {
  const alignmentClasses = {
    left: "justify-start",
    center: "justify-center",
    right: "justify-end",
  };

  const variantClasses = {
    page: "flex flex-shrink-0 px-6 py-4 space-x-3 border-t border-border",
    modal: "flex flex-shrink-0 px-6 py-4 space-x-3 border-t border-border rounded-b-lg bg-muted/30",
  };

  return (
    <div className={cn(variantClasses[variant], alignmentClasses[alignment], className)}>
      {children}
    </div>
  );
}
